export const environment = {
    name: "Staging",
    production: true,
    apiPath: "/api",
    msalConfig: {
        auth: {
            clientId: "46e11514-d8e4-4eba-8417-9eb92d401cc0",
            authority: "https://login.microsoftonline.com/536e5f13-9048-4161-b4e0-252104a3a803"
        }
    },
    apiConfig: {
        scopes: ['email', 'user.read'],
        uri: 'api://46e11514-d8e4-4eba-8417-9eb92d401cc0/access_as_user'
    },
    blobPath: "https://balticexchange.blob.core.windows.net"
};
